export default __webpack_public_path__ + "static/media/project5.37fc9fbc.jpg";